export interface DictionaryPapIndexDialogData {
    currencies: string[];
    unitNames: string[];
}
